import React from 'react';
import acceleratorLogo from '../assets/images/el-patio-completo-logo.avif';

const Accelerator = () => {
  return (
    <section className="accelerator-section">
      <div className="accelerator-content">
        <div className="accelerator-logo-container">
          <img 
            src={acceleratorLogo} 
            alt="El Patio - Andalucía Open Future" 
            className="accelerator-logo"
          />
        </div>
        <p className="accelerator-text">
          Myntar es una startup acelerada por el programa <strong>Andalucía Open Future</strong> a través de la Aceleradora <strong>El Patio</strong> con la colaboración de Telefónica, la Junta de Andalucía y el Instituto Municipal de Desarrollo Económico y Empleo de Córdoba.
        </p>
      </div>
    </section>
  );
};

export default Accelerator;

